import CountUp from "react-countup";

const LeadDataContainer = ({ text, number, prefix = "" }) => {
  const renderAnimatedCount = (val, originalPrefix) => {
    if (val == null || val === "") return val; // Return original if empty
    
    if (typeof val === 'number') {
      return <CountUp end={val} separator="," duration={2} prefix={originalPrefix} />;
    }

    const strVal = String(val);
    let currentPrefix = originalPrefix;
    let cleanStr = strVal;

    if (cleanStr.trim().startsWith('$')) {
      currentPrefix = "$";
      cleanStr = cleanStr.replace('$', '');
    }

    const num = Number(cleanStr.replace(/,/g, '').trim());
    return !isNaN(num) && cleanStr.trim() !== '' ? <CountUp end={num} separator="," duration={2} prefix={currentPrefix} /> : val;
  };

  return (
    <div 
      className="flex flex-col text-center h-[8.5rem] w-full bg-white 
                 p-4 mb-2"
      style={{ minWidth: "135x" }}   // Controlled min-width
    >
      <p className="head-2 dark-H flex items-center justify-center pb-2 mt-3 text-[22px] font-semibold">
        {renderAnimatedCount(number, prefix)}
      </p>
      <p className="body-S dark-M text-[13px] leading-tight px-1 line-clamp-2">
        {text}
      </p>
    </div>
  );
};
 
export default LeadDataContainer;